import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL

export const sendOtpInsertAgent = async (number: string, label: string, agentsId: string[], token: string) => {
    return await axios.post(`${API_URL}chat-agent/admin/phones`,
        {
            number,
            label,
            agentsId
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const updateAgent = async (id: string, number: string, label: string, agentsId: string[], token: string) => {
    return await axios.put(`${API_URL}chat-agent/admin/phones/${id}`,
        {
            number,
            label,
            agentsId
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const deleteAgent = async (id: string, token: string) => {
    return await axios.delete(`${API_URL}chat-agent/admin/phones/${id}`,
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const verifyOtpSettingAgent = async (requestId: string, otp: string, token: string) => {
    return await axios.post(`${API_URL}chat-agent/admin/phones/validate-request`,
        {
            requestId,
            otp
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}
